import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class MaintenanceNoticeService {
	private _maintenanceNoticeAPIBase = `${API_URL}/maintenanceNotice`;

	constructor(private httpManager: HttpManager) {}

	getMaintenanceNoticeStatus(): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._maintenanceNoticeAPIBase}/getStatus`);
	}

	setMaintenanceNoticeStatus(active = false): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._maintenanceNoticeAPIBase}/setStatus`, { active: active });
	}
	getMaintenanceNoticeMessage(): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._maintenanceNoticeAPIBase}/getMessage`);
	}

	setMaintenanceNoticeMessage(message = ""): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._maintenanceNoticeAPIBase}/setMessage`, { message: message });
	}
}
